// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;For he comes, he comes to judge the earth;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;with righteousness he will judge the world<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and the peoples with his truth.<br> </p> </div></div>";
// Exports
module.exports = code;